import * as momentLib from "moment";
import "moment/locale/nl";
momentLib.locale("nl");
export const moment = momentLib;
